"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var StatusPill = function StatusPill(_ref) {
  var label = _ref.label,
      backgroundColor = _ref.backgroundColor,
      textColor = _ref.textColor,
      className = _ref.className;

  if (!label) {
    return null;
  }

  return (0, _preact.h)("span", {
    style: {
      color: textColor,
      backgroundColor: backgroundColor
    },
    className: (0, _classnames.default)('status-pill', className)
  }, label);
};

var _default = StatusPill;
exports.default = _default;